export * from './app-breadcrumbs.component';



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/components/app-breadcrumbs/index.ts